/* BRG — Science page (LSME10 Technology) behaviors.
   Port of lsme10-app.jsx interactions to vanilla JS. Loaded (defer) by every
   lx-* section; the init flag keeps delegated handlers single-instance. */
(function () {
  if (window.__brgLxInit) return;
  window.__brgLxInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHECK = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6.5L4.8 9.2 10 3.4"></path></svg>';

  function bound(el, key) {
    var k = 'lxBound' + key;
    if (el.dataset[k] === '1') return true;
    el.dataset[k] = '1';
    return false;
  }

  /* ── Scroll-in reveals ── */
  function initReveals(root) {
    var els = root.querySelectorAll('.lx-set-card, .lx-lstep, .lx-comp-stack .lx-card, .lx-phil-item');
    if (!els.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('in'); });
    }, { threshold: 0.18 });
    els.forEach(function (el) { if (!bound(el, 'Reveal')) io.observe(el); });
  }

  /* ── Why-liposomes spine fill ── */
  function initSpine(root) {
    root.querySelectorAll('.lx-lipo').forEach(function (sec) {
      if (bound(sec, 'Spine')) return;
      var flow = sec.querySelector('.lx-lipo-flow');
      var fill = sec.querySelector('.lx-spine-fill');
      if (!flow || !fill) return;
      var raf = 0;
      var onScroll = function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var r = flow.getBoundingClientRect();
          var p = Math.min(1, Math.max(0, (window.innerHeight * 0.62 - r.top) / r.height));
          fill.style.transform = 'scaleY(' + p + ')';
        });
      };
      onScroll();
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      window.addEventListener('resize', onScroll);
    });
  }

  /* ── Hero visual fades out under the fold on mobile ── */
  function initHero(root) {
    root.querySelectorAll('.lx-hero-visual').forEach(function (el) {
      if (bound(el, 'Hero')) return;
      var raf = 0;
      var onScroll = function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          if (window.innerWidth > 700) { el.style.opacity = ''; return; }
          var r = el.getBoundingClientRect();
          el.style.opacity = r.top < 0 ? String(Math.max(0, 1 - (-r.top) / (r.height * 0.75))) : '';
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    });
  }

  /* ── Film section: custom player + docking mini player ──
     Media adapter unifies HTML5 <video> (Shopify Files) and YouTube (IFrame API). */
  function fmt(s) { s = Math.floor(s || 0); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); }

  function html5Adapter(vid) {
    vid.removeAttribute('controls');
    vid.muted = true;
    return {
      el: vid,
      play: function () { return vid.play().catch(function () {}); },
      pause: function () { vid.pause(); },
      isPaused: function () { return vid.paused; },
      isEnded: function () { return vid.ended; },
      time: function () { return vid.currentTime; },
      duration: function () { return vid.duration; },
      seek: function (t) { vid.currentTime = t; },
      isMuted: function () { return vid.muted; },
      setMuted: function (m) { vid.muted = m; },
      on: function (evt, fn) { vid.addEventListener(evt, fn); },
      ready: function (fn) { fn(); }
    };
  }

  var ytApiPromise = null;
  function loadYouTubeApi() {
    if (ytApiPromise) return ytApiPromise;
    ytApiPromise = new Promise(function (resolve) {
      if (window.YT && window.YT.Player) return resolve(window.YT);
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () { if (prev) prev(); resolve(window.YT); };
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    });
    return ytApiPromise;
  }

  function youtubeAdapter(host) {
    var handlers = {}, player = null, readyFns = [], ready = false, poll = null, ended = false, paused = true;
    var emit = function (evt) { (handlers[evt] || []).forEach(function (fn) { fn(); }); };
    var startPoll = function () { clearInterval(poll); poll = setInterval(function () { emit('timeupdate'); }, 250); };
    loadYouTubeApi().then(function (YT) {
      player = new YT.Player(host, {
        videoId: host.getAttribute('data-yt-id'),
        playerVars: { autoplay: 0, controls: 0, rel: 0, modestbranding: 1, playsinline: 1, disablekb: 1, mute: 1, enablejsapi: 1, origin: window.location.origin },
        events: {
          onReady: function () {
            ready = true;
            try { player.mute(); } catch (err) {}
            /* Emulate object-fit:cover — YouTube letterboxes its 16:9 frame,
               so oversize + center the iframe within whatever the stage is. */
            var iframe = player.getIframe();
            var stage = iframe && iframe.parentElement;
            if (iframe && stage) {
              iframe.setAttribute('data-lx-yt', '1');
              var fit = function () {
                var w = stage.clientWidth, h = stage.clientHeight;
                if (!w || !h) return;
                var iw, ih;
                if (w / h > 16 / 9) { iw = w; ih = w * 9 / 16; } else { ih = h; iw = h * 16 / 9; }
                iframe.style.width = Math.ceil(iw) + 'px';
                iframe.style.height = Math.ceil(ih) + 'px';
              };
              fit();
              try { new ResizeObserver(fit).observe(stage); } catch (err) { window.addEventListener('resize', fit); }
            }
            readyFns.forEach(function (fn) { fn(); });
          },
          onStateChange: function (e) {
            if (e.data === YT.PlayerState.PLAYING) { paused = false; ended = false; emit('play'); emit('playing'); startPoll(); }
            else if (e.data === YT.PlayerState.PAUSED) { paused = true; clearInterval(poll); emit('pause'); }
            else if (e.data === YT.PlayerState.ENDED) { paused = true; ended = true; clearInterval(poll); emit('timeupdate'); emit('ended'); }
          }
        }
      });
    });
    var safe = function (fn, fallback) { try { return ready ? fn() : fallback; } catch (err) { return fallback; } };
    return {
      el: host,
      play: function () { safe(function () { player.playVideo(); }); },
      pause: function () { safe(function () { player.pauseVideo(); }); },
      isPaused: function () { return paused; },
      isEnded: function () { return ended; },
      time: function () { return safe(function () { return player.getCurrentTime(); }, 0); },
      duration: function () { return safe(function () { return player.getDuration(); }, 0); },
      seek: function (t) { safe(function () { player.seekTo(t, true); }); },
      isMuted: function () { return safe(function () { return player.isMuted(); }, true); },
      setMuted: function (m) { safe(function () { m ? player.mute() : player.unMute(); }); },
      on: function (evt, fn) { (handlers[evt] = handlers[evt] || []).push(fn); },
      ready: function (fn) { ready ? fn() : readyFns.push(fn); },
      isYouTube: true
    };
  }

  function initFilm(root) {
    root.querySelectorAll('.lx-film').forEach(function (sec) {
      if (bound(sec, 'Film')) return;
      var player = sec.querySelector('.lx-film-player');
      var vid = sec.querySelector('video');
      var ytHost = sec.querySelector('.lx-film-yt');
      if (!player || (!vid && !ytHost)) return;
      var media = vid ? html5Adapter(vid) : youtubeAdapter(ytHost);
      var big = sec.querySelector('.lx-film-big');
      var playBtn = sec.querySelector('[data-lx-play]');
      var muteBtn = sec.querySelector('[data-lx-mute]');
      var fsBtn = sec.querySelector('[data-lx-fs]');
      var closeBtn = sec.querySelector('.lx-film-x');
      var bar = sec.querySelector('.lx-film-ui .bar');
      var fillI = bar && bar.querySelector('i');
      var tm = sec.querySelector('.lx-film-ui .tm');
      var played = false, closed = false, idleT = null;

      var setPlaying = function (on) {
        big.hidden = on;
        playBtn.innerHTML = on
          ? '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M5.5 4h3v12h-3zM11.5 4h3v12h-3z"></path></svg>'
          : '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M6.5 4.2v11.6L16 10z"></path></svg>';
        playBtn.setAttribute('aria-label', on ? 'Pause' : 'Play');
        if (!on) player.classList.remove('hide-ui');
      };
      var wake = function () {
        player.classList.remove('hide-ui');
        clearTimeout(idleT);
        if (media.isYouTube) return; /* iframe swallows pointer events; keep UI visible */
        idleT = setTimeout(function () { if (!media.isPaused()) player.classList.add('hide-ui'); }, 2400);
      };
      var toggle = function (e) {
        if (e) e.stopPropagation();
        if (media.isPaused() || media.isEnded()) { if (media.isEnded()) media.seek(0); media.play(); }
        else media.pause();
      };
      var seek = function (e) {
        var r = bar.getBoundingClientRect();
        var d = media.duration();
        if (d) media.seek(Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) * d);
      };
      var setMuteIcon = function () {
        var m = media.isMuted();
        muteBtn.innerHTML = m
          ? '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M3.5 7.5h3L11 4v12l-4.5-3.5h-3z" fill="currentColor" stroke="none"></path><path d="M13.5 7.5l4 5M17.5 7.5l-4 5" stroke-linecap="round"></path></svg>'
          : '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"><path d="M3.5 7.5h3L11 4v12l-4.5-3.5h-3z" fill="currentColor" stroke="none"></path><path d="M13.5 7a4 4 0 010 6" stroke-linecap="round"></path><path d="M15.5 5.2a7 7 0 010 9.6" stroke-linecap="round"></path></svg>';
        muteBtn.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
      };

      media.on('playing', function () { played = true; });
      media.on('play', function () { setPlaying(true); wake(); });
      media.on('pause', function () { setPlaying(false); });
      media.on('ended', function () { setPlaying(false); if (fillI) fillI.style.width = '100%'; });
      media.on('timeupdate', function () {
        var d = media.duration();
        if (fillI) fillI.style.width = (d ? (media.time() / d) * 100 : 0) + '%';
        if (tm) tm.textContent = fmt(media.time());
      });
      if (vid) vid.addEventListener('click', toggle);
      big.addEventListener('click', toggle);
      playBtn.addEventListener('click', toggle);
      muteBtn.addEventListener('click', function () { media.setMuted(!media.isMuted()); setMuteIcon(); });
      if (fsBtn) fsBtn.addEventListener('click', function () {
        if (document.fullscreenElement) document.exitFullscreen();
        else if (player.requestFullscreen) player.requestFullscreen();
      });
      if (bar) {
        bar.addEventListener('pointerdown', function (e) { bar.setPointerCapture(e.pointerId); seek(e); });
        bar.addEventListener('pointermove', function (e) { if (e.buttons) seek(e); });
      }
      player.addEventListener('mousemove', wake);
      player.addEventListener('touchstart', wake, { passive: true });
      if (closeBtn) closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closed = true;
        player.classList.remove('mini');
        closeBtn.hidden = true;
        media.pause();
      });
      setPlaying(false);
      media.ready(setMuteIcon);

      var io = new IntersectionObserver(function (es) {
        var e = es[0];
        if (e.isIntersecting) {
          sec.classList.add('in');
          // `closed` intentionally persists: once a visitor dismisses the
          // mini player it stays dismissed until the page is reloaded.
          player.classList.remove('mini');
          if (closeBtn) closeBtn.hidden = true;
          if (sec.dataset.autoplay === 'true') media.ready(function () { media.play(); });
        } else if (e.boundingClientRect.top < 0 && played && !closed && sec.dataset.dock === 'true') {
          player.classList.add('mini');
          if (closeBtn) closeBtn.hidden = false;
        } else {
          media.pause();
        }
      }, { threshold: 0.35 });
      io.observe(sec);
      sec.__lxPlay = function () { if (media.isEnded()) media.seek(0); media.ready(function () { media.play(); }); };
    });
  }

  /* ── Collection rail (mobile carousel: arrows + dots) ── */
  function initRail(root) {
    root.querySelectorAll('.lx-set').forEach(function (sec) {
      if (bound(sec, 'Rail')) return;
      var rail = sec.querySelector('.lx-set-rail');
      var wrap = sec.querySelector('.lx-set-railwrap');
      var prev = sec.querySelector('.lx-set-arrow.prev');
      var next = sec.querySelector('.lx-set-arrow.next');
      var dotsEl = sec.querySelector('.lx-set-dots');
      if (!rail) return;
      var dots = 1, ix = 0;
      var stepOf = function () {
        var cards = rail.querySelectorAll('.lx-set-card');
        return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 0;
      };
      var render = function () {
        if (prev) prev.disabled = ix === 0;
        if (next) next.disabled = ix >= dots - 1;
        if (dotsEl) {
          dotsEl.innerHTML = '';
          for (var i = 0; i < dots; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = i === ix ? 'on' : '';
            b.setAttribute('aria-label', 'Go to position ' + (i + 1));
            b.dataset.ix = i;
            dotsEl.appendChild(b);
          }
        }
        var show = dots > 1;
        if (prev) prev.hidden = !show;
        if (next) next.hidden = !show;
        if (dotsEl) dotsEl.hidden = !show;
      };
      var calc = function () {
        var step = stepOf();
        dots = step > 0 ? 1 + Math.round(Math.max(0, rail.scrollWidth - rail.clientWidth) / step) : 1;
        var vis = rail.querySelector('.lx-set-card .vis');
        if (wrap && vis) {
          var wr = wrap.getBoundingClientRect(), vr = vis.getBoundingClientRect();
          wrap.style.setProperty('--ay', (vr.top - wr.top + vr.height / 2) + 'px');
        }
        render();
      };
      var goTo = function (i) { rail.scrollTo({ left: i * stepOf(), behavior: 'smooth' }); };
      rail.addEventListener('scroll', function () {
        var step = stepOf();
        if (step > 0) { ix = Math.max(0, Math.min(dots - 1, Math.round(rail.scrollLeft / step))); render(); }
      }, { passive: true });
      if (prev) prev.addEventListener('click', function () { goTo(ix - 1); });
      if (next) next.addEventListener('click', function () { goTo(ix + 1); });
      if (dotsEl) dotsEl.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-ix]');
        if (b) goTo(parseInt(b.dataset.ix, 10));
      });
      calc();
      window.addEventListener('resize', calc);
    });
  }

  /* ── Modals (moved to <body> so position:fixed escapes section containment) ── */
  var openModal = null;
  function closeModal() {
    if (!openModal) return;
    var m = openModal;
    openModal = null;
    m.classList.add('out');
    var ask = m.querySelector('.lx-ask');
    if (ask) ask.hidden = true;
    setTimeout(function () { m.classList.remove('out'); m.hidden = true; }, 380);
  }
  var modalHost = null;
  function showModal(id) {
    var m = document.getElementById(id);
    if (!m) return;
    if (!modalHost) {
      // A .lx host on <body> keeps the design tokens in scope for relocated
      // modals without size containment (which would trap position:fixed).
      modalHost = document.createElement('div');
      modalHost.className = 'lx lx--no-contain';
      modalHost.style.background = 'transparent';
      document.body.appendChild(modalHost);
    }
    if (m.parentElement !== modalHost) modalHost.appendChild(m);
    if (openModal && openModal !== m) { openModal.hidden = true; }
    m.hidden = false;
    m.classList.remove('out');
    openModal = m;
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lx-open]');
    if (opener) { e.preventDefault(); showModal(opener.getAttribute('data-lx-open')); return; }
    if (!openModal) return;
    if (e.target.closest('.lx-modal-x') || e.target === openModal) { closeModal(); return; }
    var askBg = e.target.closest('.lx-ask');
    if (askBg && e.target === askBg) { askBg.hidden = true; return; }
    if (e.target.closest('[data-lx-continue]')) { e.preventDefault(); closeModal(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  /* ── Review star (product modal) ── */
  function initReviewStar(root) {
    root.querySelectorAll('.lx-rstar-wrap').forEach(function (wrap) {
      if (bound(wrap, 'Star')) return;
      var btn = wrap.querySelector('.lx-rstar');
      var fly = wrap.querySelector('.lx-rstar-fly');
      var reviews = [];
      try { reviews = JSON.parse(wrap.getAttribute('data-reviews') || '[]'); } catch (err) {}
      if (!btn || !fly || !reviews.length) return;
      var ix = 0, timer = null, open = false;
      var paint = function () {
        var r = reviews[ix];
        fly.querySelector('p').textContent = '“' + r.q + '”';
        fly.querySelector('footer').innerHTML = '';
        fly.querySelector('footer').append(r.n + ' ');
        var em = document.createElement('em'); em.textContent = '· Verified buyer';
        fly.querySelector('footer').appendChild(em);
      };
      var show = function () {
        ix = Math.floor(Math.random() * reviews.length);
        paint(); fly.hidden = false; open = true; btn.classList.add('on');
        clearInterval(timer);
        timer = setInterval(function () { ix = (ix + 1) % reviews.length; paint(); }, 1000);
      };
      var hide = function () { fly.hidden = true; open = false; btn.classList.remove('on'); clearInterval(timer); };
      wrap.addEventListener('mouseenter', show);
      wrap.addEventListener('mouseleave', hide);
      btn.addEventListener('click', function () { open ? hide() : show(); });
    });
  }

  /* ── Add to cart (lx buttons) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lx-atc]');
    if (!btn || btn.dataset.busy === '1') return;
    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;
    btn.dataset.busy = '1';
    var original = btn.innerHTML;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      btn.classList.add('added');
      btn.innerHTML = '<span class="lx-btn-added">' + CHECK + (btn.getAttribute('data-added-label') || 'Added to Cart') + '</span>';
      if (window.brgCart) { window.brgCart.refreshCartCount(); window.brgCart.refreshCartDrawer(); }
      var ask = btn.closest('.lx-modal') && btn.closest('.lx-modal').querySelector('.lx-ask');
      if (ask) ask.hidden = false;
      setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = original; btn.dataset.busy = '0'; }, 2200);
    }).catch(function () {
      btn.innerHTML = original; btn.dataset.busy = '0';
      window.location.href = '/cart/add?id=' + variantId + '&quantity=1';
    });
  });

  /* ── Jump links ── */
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-lx-jump-film]');
    if (jump) {
      e.preventDefault();
      var sec = document.querySelector('.lx-film');
      if (!sec) return;
      window.scrollTo({ top: sec.offsetTop - Math.max(0, (window.innerHeight - sec.offsetHeight) / 2), behavior: 'smooth' });
      if (sec.__lxPlay) sec.__lxPlay();
      return;
    }
    var sl = e.target.closest('[data-lx-scroll]');
    if (sl) {
      var id = (sl.getAttribute('href') || '').replace('#', '');
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
    }
  });

  function initAll(root) {
    initReveals(root); initSpine(root); initHero(root); initFilm(root); initRail(root); initReviewStar(root);
    if (reduceMotion) root.querySelectorAll('.lx video[autoplay]').forEach(function (v) { try { v.pause(); } catch (err) {} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
